import React from "react";
import { IIconProps } from "./iconProps";

const EditIcon: React.FC<IIconProps> = (props) => {
  return (
    <svg {...props} viewBox="0 0 21.171 18.822">
      <path
        fill="currentColor"
        d="M14.787 12.605l1.176-1.176a.3.3 0 01.5.21v5.344a1.765 1.765 0 01-1.763 1.764H1.764A1.765 1.765 0 010 16.983V4.045A1.765 1.765 0 011.764 2.28h10.053a.3.3 0 01.21.5l-1.176 1.18a.291.291 0 01-.21.085H1.764v12.938H14.7v-4.172a.289.289 0 01.087-.206zm5.756-7.417l-9.652 9.652-3.323.368a1.518 1.518 0 01-1.676-1.676l.368-3.323L15.912.556a2.145 2.145 0 013.04 0l1.588 1.588a2.153 2.153 0 010 3.043zm-3.631 1.135l-2.136-2.135-6.829 6.833-.268 2.4 2.4-.268zm2.382-2.93l-1.588-1.587a.384.384 0 00-.544 0l-1.136 1.136 2.136 2.136L19.3 3.942a.392.392 0 00-.006-.548z"
      ></path>
    </svg>
  );
};

export default EditIcon;
